import { Image } from './Image';
import { alpha, styled } from '@mui/material';
import { VinImageIds } from '@/constants/imageTypes';

interface VinImageProps {
  id: VinImageIds;
  alt: string | null;
  width: string | null;
}

export function VinImage({ id, alt, width }: VinImageProps) {
  const MARKER_CONFIG = {
    [VinImageIds.VIN_FRONT]: {
      imageId: 'vin-front',
      markers: [
        {
          pos: {
            x: 53,
            y: 13,
          },
        },
      ],
    },
    [VinImageIds.VIN_SIDE]: {
      imageId: 'vin-side',
      markers: [
        {
          pos: {
            x: 42,
            y: 47,
          },
        },
      ],
    },
    [VinImageIds.VIN_ETCHING_FRONT]: {
      imageId: 'vin-front',
      markers: [
        {
          pos: {
            x: 50,
            y: 0,
          },
        },
      ],
    },
    [VinImageIds.VIN_ETCHING_SIDE]: {
      imageId: 'vin-side',
      markers: [
        {
          pos: {
            x: 30,
            y: 18,
          },
        },
        {
          pos: {
            x: 56,
            y: 15,
          },
        },
      ],
    },
    [VinImageIds.ELANTRA_FRONT]: {
      imageId: 'elantra-front',
      markers: [
        {
          pos: {
            x: 53,
            y: 21,
          },
        },
      ],
    },
    [VinImageIds.ELANTRA_DRIVER_SIDE_DOOR]: {
      imageId: 'elantra-driver-side-door',
      markers: [
        {
          pos: {
            x: 23,
            y: 39,
          },
        },
      ],
    },
  };

  return (
    <Container>
      {MARKER_CONFIG[id].markers.map((marker, index) => (
        <VinMarker
          key={index}
          xPos={marker.pos.x}
          yPos={marker.pos.y}
        />
      ))}
      <Image
        id={MARKER_CONFIG[id].imageId}
        alt={alt}
        width={width}
        backgroundColor={null}
      />
    </Container>
  );
}

const Container = styled('div')`
  position: relative;
`;

const VinMarker = styled('div')<{ xPos: number; yPos: number }>`
  position: absolute;
  z-index: 2;
  top: ${(props) => props.yPos}%;
  left: ${(props) => props.xPos}%;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1.5px solid var(--mui-palette-primary-main);
  background-image: radial-gradient(
    circle at center,
    ${({ theme }) => alpha(theme.palette.primary.main, 0.5)} 10%,
    ${({ theme }) => alpha(theme.palette.primary.main, 0.15)} 100%
  );

  &::before {
    content: '';
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 3.5px;
    border-radius: 1px;
    background-color: white;
    box-shadow: 0 0 8px 1px var(--mui-palette-primary-main);
  }
`;
